var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg247Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0857 9.20957C21.743 4.52424 17.8004 0.80957 13.0004 0.80957C8.20035 0.80957 4.25769 4.52424 3.91502 9.20957C1.91502 9.6669 0.429688 11.3816 0.429688 13.3816C0.429688 15.3816 1.91502 17.0962 3.91502 17.5522C4.25769 22.2389 8.20035 25.9522 13.0004 25.9522H16.4297V23.6669H13.0004C9.22969 23.6669 6.14302 20.5816 6.14302 16.8096V9.95357C6.14302 6.1829 9.22969 3.09757 13.0004 3.09757C16.7724 3.09757 19.8577 6.1829 19.8577 9.95357V16.5256C19.8587 16.8283 19.9795 17.1183 20.1935 17.3324C20.4076 17.5465 20.6976 17.6672 21.0004 17.6682C23.515 17.6682 25.5724 15.7256 25.5724 13.3829C25.5724 11.3829 24.087 9.66824 22.087 9.2109L22.0857 9.20957ZM2.71502 13.3816C2.71502 12.6389 3.17235 12.0096 3.85769 11.6669V15.0962C3.17235 14.7522 2.71502 14.1242 2.71502 13.3816ZM22.143 15.0962V11.6669C22.8297 12.0096 23.287 12.6389 23.287 13.3816C23.287 14.1242 22.8297 14.7522 22.143 15.0962Z",
    fill: "#7F84F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg247Icon);
export default __webpack_public_path__ + "static/media/247-icon.60d121f007bfe1de0df901d8acf8adc3.svg";
export { ForwardRef as ReactComponent };